import { responsiveFontSizes } from '../utils/getFontValue';

// Based on Adobe Trade Gothic Next Font Weights
export const fontWeight = {
  light: 300,
  regular: 400,
  bold: 700,
  heavy: 800,
} as const;

export const typography = {
  fontFamily: ['trade-gothic-next', 'sans-serif'].join(','),
  h1: {
    ...responsiveFontSizes({ xs: 32, md: 40, lg: 46 }),
  },
  h2: {
    ...responsiveFontSizes({ xs: 24, md: 28, lg: 32 }),
  },
  h3: {
    ...responsiveFontSizes({ xs: 18, md: 20, lg: 24 }),
  },
} as const;
